module.exports = __webpack_public_path__ + "media/components/src/assets/images/method/mastercard-a33f3b1017877ac62c3e0a9d94f30fa7.png";